import type { DomainEvent, GameStore } from "@dawn/engine";
import { resolveSoundTrigger } from "./audio/soundPolicy.ts";
import type { GameAudioTrigger } from "./audio/types.ts";
import type { AudioPlayerPort, LoggerPort } from "./ports.ts";

const noopLogger: LoggerPort = {
  debug() {},
  info() {},
  warn() {},
};

export function mapAudioTriggersFromEvents(
  events: readonly DomainEvent[],
): GameAudioTrigger[] {
  const triggers: GameAudioTrigger[] = [];

  for (const event of events) {
    switch (event.type) {
      case "Victory":
        triggers.push({ type: "outcome", kind: "victory" });
        break;
      case "Defeat":
        triggers.push({ type: "outcome", kind: "defeat" });
        break;
      case "TerrainEntered":
        triggers.push({
          type: "tileEntered",
          terrain: event.terrain,
        });
        break;
      case "RandomEventStarted":
        triggers.push({ type: "randomEventStarted", eventId: event.eventId });
        break;
      default:
        break;
    }
  }

  return triggers;
}

export function playAudioTrigger(
  player: AudioPlayerPort,
  trigger: GameAudioTrigger,
  logger: LoggerPort = noopLogger,
): void {
  const soundId = resolveSoundTrigger(trigger);
  if (soundId) {
    logger.debug("audio", "audio_trigger", undefined, { trigger, soundId });
    player.play(soundId);
    return;
  }

  logger.debug("audio", "audio_trigger_unmapped", undefined, { trigger });
}

export function attachAudioAdapter(
  store: GameStore,
  player: AudioPlayerPort,
  logger: LoggerPort = noopLogger,
): () => void {
  return store.on((events) => {
    for (const trigger of mapAudioTriggersFromEvents(events)) {
      playAudioTrigger(player, trigger, logger);
    }
  });
}
